<template>
  <span
    class="text-color-topaz-light hover:cursor-pointer text-base"
    @click="openModal(MAP)"
    >{{ $t("profiles.buttons.seeMap") }}</span
  >
  <modal-template v-if="activeModal === MAP" :title="title" @close="closeModal">
    <wegow-google-maps :location="location" style="min-height: 500px;" />
  </modal-template>
</template>
<script setup>
import ModalTemplate from "./ModalTemplate.vue";
import WegowGoogleMaps from "../forms/WegowGoogleMaps.vue";
import { ref, toRefs } from "vue";
import { useModalHandler } from "@/plugins/useModalHandler";

const props = defineProps({
  location: {
    type: Object,
    default: undefined
  },
  title: {
    type: String,
    default: undefined
  }
});

const { MAP, activeModal, openModal, closeModal } = useModalHandler();
const { location, title } = toRefs(props);

const openGoogleMapsModal = ref(false);
</script>
<style lang="scss"></style>
